import React from 'react'
import FuneralList from './FuneralList'

const OmasFunerals = ({ history }) => <FuneralList history={history} filter={{ accountingIdentifier: 'OMAS' }} />

export default OmasFunerals
